import React, { useEffect } from 'react';
import classNames from 'classnames';
import FocusTrap from 'focus-trap-react';
import style from './index.module.scss';
import Pane from './pane';
import { jsx as _jsx } from "react/jsx-runtime";
export const Nav = ({
  className,
  items,
  initialPath,
  onClose,
  menuId
}) => {
  useEffect(() => {
    function keyHandler(e) {
      if (e.key === 'Escape') {
        onClose();
      }
    }

    window.addEventListener('keydown', keyHandler);
    return () => window.removeEventListener('keydown', keyHandler);
  }, [onClose]);
  return /*#__PURE__*/_jsx(FocusTrap, {
    children: /*#__PURE__*/_jsx("div", {
      // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      className: classNames(className, style.nav),
      id: menuId,
      onClick: onClose,
      children: /*#__PURE__*/_jsx("div", {
        // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        className: classNames(style.contents),
        onClick: e => e.stopPropagation(),
        children: /*#__PURE__*/_jsx(Pane, {
          items: items,
          initialPath: initialPath,
          onExit: onClose
        })
      })
    })
  });
};